const PresentIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="20"
      height="20"
      x="0"
      y="0"
      viewBox="0 0 36 36"
      xmlSpace="preserve"
      className=""
    >
      <g>
        <path
          d="M18 20c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm10 6c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM8 20c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm20 7c-2.09 0-3.92 1.07-5 2.69-1.08-1.62-2.91-2.69-5-2.69s-3.92 1.07-5 2.69A5.996 5.996 0 0 0 2 27v7c0 .55.45 1 1 1h30c.55 0 1-.45 1-1v-7c0-3.31-2.69-6-6-6zM4 27c0-2.21 1.79-4 4-4s4 1.79 4 4v6H4zm10 0c0-2.21 1.79-4 4-4s4 1.79 4 4v6h-8zm18 6h-8v-6c0-2.21 1.79-4 4-4s4 1.79 4 4zM15.29 4.71A.996.996 0 1 1 16.7 3.3l1.29 1.29 3.29-3.29a.996.996 0 1 1 1.41 1.41l-4 4c-.2.2-.45.29-.71.29s-.51-.1-.71-.29l-2-2zm10 0A.996.996 0 1 1 26.7 3.3l1.29 1.29 3.29-3.29a.996.996 0 1 1 1.41 1.41l-4 4c-.2.2-.45.29-.71.29s-.51-.1-.71-.29l-2-2zm-20.3.77L6.4 4.07 4.99 2.66A.996.996 0 1 1 6.4 1.25l1.41 1.41 1.41-1.41a.996.996 0 1 1 1.41 1.41L9.22 4.07l1.41 1.41a.996.996 0 0 1-.71 1.7c-.26 0-.51-.1-.71-.29L7.8 5.48 6.39 6.89c-.2.2-.45.29-.71.29s-.51-.1-.71-.29a.996.996 0 0 1 0-1.41z"
          fill="#ffffff"
          opacity="1"
          data-original="#ffffff"
          className=""
        />
      </g>
    </svg>
  );
};
export default PresentIcon;
